import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input} from '@angular/core'
import {DocumentService} from '../../../../craft/utils/document.service'
import {DOCUMENT} from '@angular/common'

@Component({
  selector: 'cft-toc-item',
  templateUrl: './toc-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TocItemComponent {
  @Input() set active(value: boolean) {
    this._active = value
    this.cdr.markForCheck()
  }
  get active(): boolean {
    return this._active
  }

  @Input() anchor!: HTMLElement | string
  @Input() offsetMargin = 300

  private _active = false

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly documentService: DocumentService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  getAnchorElement() {
    if (typeof this.anchor === 'string') {
      const result = this.document.getElementById(this.anchor)
      if (!result) throw new RangeError(`Could not scroll to TOC item. ${this.anchor} was not found in document`)

      return result
    }

    return this.anchor
  }

  scrollToElement() {
    this.documentService.scrollToElement(this.getAnchorElement(), {topOffset: -100})
  }
}
